import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination, Lazy } from 'swiper/core'
import { attachLinkInterceptor } from '../experience_link_interceptor'

Swiper.use([Navigation, Pagination, Lazy])
export default class extends Controller {
  static targets = ['reviewList', 'nextButton', 'prevButton', 'pagination']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    // パターン1（口コミあり）ではSwiperで口コミをスライド表示。
    // パターン3（口コミなし）では reviewListTarget が存在しないためSwiper初期化はスキップ。
    if (this.hasReviewListTarget) {
      const swiper = new Swiper(this.reviewListTarget, {
        slidesPerView: 2,
        spaceBetween: 12,
        navigation: {
          nextEl: this.nextButtonTarget,
          prevEl: this.prevButtonTarget,
        },
        pagination: {
          el: this.paginationTarget,
          clickable: true,
          bulletActiveClass: `${this.className}::active`,
        },
      })

      swiper.enable()
    }

    // 章アンカー付き「続きをみる」クリック横取り処理を共通モジュールに委譲する (#10592)。
    // handleClick のロジック本体は experience_link_interceptor.js 側で desktop/mobile 共通定義。
    this.detachLinkInterceptor = attachLinkInterceptor(this.element)
  }

  disconnect () {
    if (this.detachLinkInterceptor) {
      this.detachLinkInterceptor()
    }
  }
}
